import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { router } from './router';
import { ToastContainer, ConfirmDialog } from './shared/ui';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is considered fresh for 30 seconds before re-fetching
      staleTime: 30_000,
      // Keep inactive query data in cache for 5 minutes
      gcTime: 5 * 60_000,
      // Retry failed requests once, but never on auth errors (403/401)
      retry: (count, error) => {
        const status = (error as { status?: number })?.status;
        if (status === 401 || status === 403) return false;
        return count < 1;
      },
      // Don't refetch on window focus (can be annoying in a payroll app)
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <ToastContainer />
      <ConfirmDialog />
    </QueryClientProvider>
  );
}
